const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-brush"),
    require("d3-zoom"),
    require("d3-scale")
)

export default function drawBase() {
    d3.select("#d3-root").remove() // Cleaning for hot refresh

    this.wrapper = d3
        .select(`#${this.DOMtarget}`)
        .append("svg")
        .attr("width", this.dimensions.width)
        .attr("height", this.dimensions.height)
        .attr("class", "wrapper")
        .attr("id", "d3-root")
        .append("g")
        .attr("id", "container")
        .attr(
            "transform",
            `translate(${this.dimensions.width / 2},${this.dimensions.height /
                2})`
        )
        .attr("width", this.dimensions.width / 2)
        .attr("height", this.dimensions.height / 2)

    this.wrapper
        .append("g")
        .attr("id", "arcs")
        .attr("transform", `translate(${0},${this.dimensions.histogram})`)
    this.wrapper
        .append("g")
        .attr("id", "ribbons")
        .attr("transform", `translate(${0},${this.dimensions.histogram})`)
    this.wrapper
        .append("g")
        .attr("id", "labels")
        .attr("transform", `translate(${0},${this.dimensions.histogram})`)
    this.wrapper
        .append("g")
        .attr("id", "brush")
        

    this.createBrush()
}
